import { useEffect, useState } from 'react';
import { parseCookies, setCookie } from 'nookies';
import Modal from '@components/elements/modal/modal';
import { useTranslation } from 'next-i18next';
import { formatCurrency } from '@utils/format';
import { useMedia } from '@hooks/use-media';
import { StarIcon } from '@components/icons/star-icon';
import DottedLine from '@components/icons/dotted-line';
import Button from '@components/elements/button/button';
import { isSome, v2_useCmsBlock } from '@crocodille/common';
import cn from 'classnames';

import styles from './app-modal.module.scss';

const APP_MODAL_DISMISSED_COOKIE = 'app_modal_dismissed';

const AppModal: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const isMobile = useMedia('app-modal', true);
  const shown = open && isMobile;

  const { data: block } = v2_useCmsBlock('app_promo_banner');

  const onClose = () => {
    setCookie(null, APP_MODAL_DISMISSED_COOKIE, 'true', {
      maxAge: 60 * 60 * 14,
      path: '/',
    });

    setOpen(false);
  };

  const onCopy = async () => {
    await navigator.clipboard.writeText('POPRVE50');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    if (isSome(block)) {
      setTimeout(
        () =>
          setOpen(() => {
            return parseCookies()[APP_MODAL_DISMISSED_COOKIE] !== 'true';
          }),
        2000,
      );
    }
  }, [block, isMobile]);

  return (
    <Modal
      open={shown}
      onClose={onClose}
      title=""
      height="fill"
      showCloseButton
      hideTitle
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.titleContainer}>
              <h2>{t('app_download.title')}</h2>
              <StarIcon className={cn(styles.star, styles.left)} />
              <StarIcon className={cn(styles.star, styles.right)} />
              <StarIcon className={cn(styles.star, styles.small)} />
              <h1>{formatCurrency(5000, 'CZK', i18n.language)}</h1>
            </div>
            <div className={styles.subtitle}>{t('app_download.subtitle')}</div>
            <div className={styles.stepsContainer}>
              <p>{t('app_download.step_1')}</p>
              <p>{t('app_download.step_2')}</p>
              <p>{t('app_download.step_3')}</p>
              <p>{t('app_download.step_4')}</p>
              <DottedLine className={styles.line} />
              <StarIcon className={cn(styles.star, styles.bottom)} />
            </div>
            <div className={styles.subtitle}>{t('app_download.code')}</div>
            <div className={styles.codeContainer}>
              <div>POPRVE50</div>
              <Button onClick={onCopy}>
                {copied
                  ? t('app_download.copied')
                  : t('app_download.copy_code')}
              </Button>
            </div>
            <Button
              as="a"
              href={block?.link ?? undefined}
              className={styles.downloadBtn}
            >
              {t('app_download.button')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AppModal;
